/* ==========================================================
   KARIA TECHNOLOGIES — SHARED SCRIPTS
========================================================== */

/* HERO INTRO */
window.addEventListener('load', () => {
  document.body.classList.add('loaded');
  document.querySelectorAll('.hero .word-reveal, .page-hero .word-reveal').forEach(w => {
    const parent = w.closest('[id]');
    if (parent) parent.classList.add('in-view');
  });
});

/* CURSOR */
(function () {
  const cursor = document.querySelector('.cursor');
  const ring = document.querySelector('.cursor-ring');
  if (!cursor || !ring) return;
  let mx = 0, my = 0, rx = 0, ry = 0;
  document.addEventListener('mousemove', (e) => {
    mx = e.clientX; my = e.clientY;
    cursor.style.left = mx + 'px';
    cursor.style.top = my + 'px';
  });
  function loop() {
    rx += (mx - rx) * 0.18;
    ry += (my - ry) * 0.18;
    ring.style.left = rx + 'px';
    ring.style.top = ry + 'px';
    requestAnimationFrame(loop);
  }
  loop();
  document.querySelectorAll('a, button, .magnetic, .bento-item, .tech-step, .market-point, .faq-item, .product-card, .spec-row, .gallery-item').forEach(el => {
    el.addEventListener('mouseenter', () => ring.classList.add('hover'));
    el.addEventListener('mouseleave', () => ring.classList.remove('hover'));
  });
})();

/* MAGNETIC BUTTONS — hardened so the pull can never eat a click.
   Guard prevents double-binding (this file + section inline copies); the button
   snaps back to home on press so mousedown & mouseup land on the same element. */
document.querySelectorAll('.magnetic').forEach(btn => {
  if (btn.dataset.magBound) return;
  btn.dataset.magBound = '1';
  let pressed = false;
  btn.addEventListener('mousemove', (e) => {
    if (pressed) return;
    const r = btn.getBoundingClientRect();
    const x = e.clientX - r.left - r.width/2;
    const y = e.clientY - r.top - r.height/2;
    btn.style.transform = `translate(${x*0.14}px, ${y*0.18}px)`;
  });
  btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
  // Freeze in place on press (do NOT move the button) so mousedown & mouseup land
  // on the same spot — snapping home here could slide an edge out from under the cursor.
  btn.addEventListener('pointerdown', () => { pressed = true; });
  ['pointerup','pointercancel','blur'].forEach(ev => btn.addEventListener(ev, () => { pressed = false; }));
});

/* NAV SCROLL */
const nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
}

/* MOBILE NAV */
const burger = document.getElementById('burger');
const mobileNav = document.getElementById('mobileNav');
const mobileClose = document.getElementById('mobileClose');
if (burger && mobileNav) {
  burger.addEventListener('click', () => mobileNav.classList.add('open'));
  if (mobileClose) mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'));
  document.querySelectorAll('.m-link').forEach(a => a.addEventListener('click', () => mobileNav.classList.remove('open')));
}

/* SCROLL REVEAL */
const revealObs = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in', 'in-view'); });
}, { threshold: 0.05, rootMargin: '80px 0px 0px 0px' });
document.querySelectorAll('.reveal, .section-title, .section-desc').forEach(el => revealObs.observe(el));

/* MARKET BARS */
const marketBars = document.getElementById('marketBars');
if (marketBars) {
  const bo = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        marketBars.querySelectorAll('.market-bar').forEach((b, i) => {
          setTimeout(() => {
            b.style.height = b.dataset.h;
            b.parentElement.classList.add('visible');
          }, i * 120);
        });
        bo.unobserve(e.target);
      }
    });
  }, { threshold: 0.4 });
  bo.observe(marketBars);
}

/* FAQ */
document.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const open = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
    if (!open) item.classList.add('open');
  });
});

/* GSAP SCROLL TRIGGERS */
if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);

  /* Hero parallax removed — left & right columns scroll together with the page as one (no split/differential scroll) */

  const diffStat = document.getElementById('diffStat');
  if (diffStat) {
    gsap.from(diffStat, { scale: 0.6, opacity: 0, duration: 1.2, scrollTrigger: { trigger: diffStat, start: 'top 80%' } });
  }

  /* section-title visibility handled by .reveal CSS system — no gsap override needed */
}

/* LEGACY HERO 3D — disabled in favor of the product model carousel */
(function initHero3D() {
  if (typeof THREE === 'undefined') return;
  const canvas = document.getElementById('hero-diamond-canvas');
  if (!canvas) return;

  const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(45, 1, 0.1, 100);
  camera.position.set(0, 0, 8);

  function resize() {
    const w = canvas.parentElement.clientWidth;
    const h = canvas.parentElement.clientHeight;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }

  function buildDiamond() {
    const group = new THREE.Group();
    const verts = [];
    const N = 16;
    const tableR = 0.65, girdleR = 1.4, culetR = 0.05;
    const tableY = 0.6, girdleY = 0.0, culetY = -1.4;

    verts.push(new THREE.Vector3(0, tableY + 0.05, 0));
    for (let i = 0; i < N; i++) { const a = (i/N)*Math.PI*2; verts.push(new THREE.Vector3(tableR*Math.cos(a), tableY, tableR*Math.sin(a))); }
    for (let i = 0; i < N; i++) { const a = ((i+0.5)/N)*Math.PI*2; verts.push(new THREE.Vector3(girdleR*Math.cos(a), girdleY, girdleR*Math.sin(a))); }
    for (let i = 0; i < N; i++) { const a = (i/N)*Math.PI*2; verts.push(new THREE.Vector3(culetR*6*Math.cos(a), culetY*0.4, culetR*6*Math.sin(a))); }
    verts.push(new THREE.Vector3(0, culetY, 0));

    const idxTop = 0, idxTab = 1, idxGir = 1+N, idxLow = 1+N+N, idxCul = 1+N+N+N;
    const faces = [];
    for (let i = 0; i < N; i++) {
      const tA = idxTab+i, tB = idxTab+(i+1)%N, gA = idxGir+i, gB = idxGir+(i+1)%N;
      faces.push([tA,gA,tB]); faces.push([tB,gA,gB]);
    }
    for (let i = 0; i < N; i++) { faces.push([idxTop, idxTab+i, idxTab+(i+1)%N]); }
    for (let i = 0; i < N; i++) {
      const gA = idxGir+i, gB = idxGir+(i+1)%N, lA = idxLow+i, lB = idxLow+(i+1)%N;
      faces.push([gA,lA,gB]); faces.push([gB,lA,lB]);
    }
    for (let i = 0; i < N; i++) { faces.push([idxLow+i, idxCul, idxLow+(i+1)%N]); }

    const positions = [], normals = [];
    faces.forEach(([a,b,c]) => {
      const va=verts[a], vb=verts[b], vc=verts[c];
      const ab=new THREE.Vector3().subVectors(vb,va);
      const ac=new THREE.Vector3().subVectors(vc,va);
      const n=new THREE.Vector3().crossVectors(ab,ac).normalize();
      [va,vb,vc].forEach(v=>{positions.push(v.x,v.y,v.z);normals.push(n.x,n.y,n.z);});
    });

    const geom = new THREE.BufferGeometry();
    geom.setAttribute('position', new THREE.Float32BufferAttribute(positions,3));
    geom.setAttribute('normal', new THREE.Float32BufferAttribute(normals,3));

    const shell = new THREE.Mesh(geom, new THREE.MeshPhongMaterial({color:0x7dd3fc,transparent:true,opacity:0.35,shininess:200,specular:0xffffff,side:THREE.DoubleSide,flatShading:true}));
    group.add(shell);
    const wire = new THREE.Mesh(geom, new THREE.MeshBasicMaterial({color:0xd6f1ff,wireframe:true,transparent:true,opacity:0.4}));
    wire.scale.setScalar(1.001);
    group.add(wire);
    const core = new THREE.Mesh(geom, new THREE.MeshPhongMaterial({color:0x0c1a2e,transparent:true,opacity:0.85,shininess:150,specular:0xffffff,side:THREE.DoubleSide,flatShading:true}));
    core.scale.setScalar(0.92);
    group.add(core);
    return group;
  }

  const diamond = buildDiamond();
  diamond.rotation.x = 0.2;
  scene.add(diamond);

  scene.add(new THREE.Mesh(new THREE.SphereGeometry(2.2,32,32), new THREE.MeshBasicMaterial({color:0x22d3ee,transparent:true,opacity:0.06,side:THREE.BackSide})));
  const halo2 = new THREE.Mesh(new THREE.SphereGeometry(2.6,32,32), new THREE.MeshBasicMaterial({color:0x8b5cf6,transparent:true,opacity:0.04,side:THREE.BackSide}));
  scene.add(halo2);

  const pCount = 250;
  const pPos = new Float32Array(pCount*3), pVel = new Float32Array(pCount*3);
  for (let i = 0; i < pCount; i++) {
    const r=2.5+Math.random()*3, theta=Math.random()*Math.PI*2, phi=Math.acos(2*Math.random()-1);
    pPos[i*3]=r*Math.sin(phi)*Math.cos(theta); pPos[i*3+1]=r*Math.sin(phi)*Math.sin(theta); pPos[i*3+2]=r*Math.cos(phi);
    pVel[i*3]=(Math.random()-0.5)*0.005; pVel[i*3+1]=(Math.random()-0.5)*0.005; pVel[i*3+2]=(Math.random()-0.5)*0.005;
  }
  const pGeo = new THREE.BufferGeometry();
  pGeo.setAttribute('position', new THREE.Float32BufferAttribute(pPos,3));
  const pCanvas = document.createElement('canvas');
  pCanvas.width = pCanvas.height = 64;
  const pCtx = pCanvas.getContext('2d');
  const pGrad = pCtx.createRadialGradient(32,32,0,32,32,32);
  pGrad.addColorStop(0,'rgba(255,255,255,1)');
  pGrad.addColorStop(0.5,'rgba(125,211,252,0.5)');
  pGrad.addColorStop(1,'rgba(125,211,252,0)');
  pCtx.fillStyle = pGrad; pCtx.fillRect(0,0,64,64);
  const points = new THREE.Points(pGeo, new THREE.PointsMaterial({size:0.08,map:new THREE.CanvasTexture(pCanvas),transparent:true,blending:THREE.AdditiveBlending,depthWrite:false,color:0xffffff}));
  scene.add(points);

  function makeRing(r,c,o,t){const g=new THREE.TorusGeometry(r,0.005,8,100);const m=new THREE.MeshBasicMaterial({color:c,transparent:true,opacity:o,side:THREE.DoubleSide});const ring=new THREE.Mesh(g,m);ring.rotation.x=t.x;ring.rotation.y=t.y;ring.rotation.z=t.z;return ring;}
  const r1=makeRing(2.4,0x22d3ee,0.4,{x:Math.PI/3,y:0,z:0});
  const r2=makeRing(2.8,0x8b5cf6,0.3,{x:0,y:Math.PI/3,z:Math.PI/4});
  const r3=makeRing(3.2,0xec4899,0.25,{x:Math.PI/4,y:Math.PI/4,z:0});
  scene.add(r1,r2,r3);

  function makeDot(c){return new THREE.Mesh(new THREE.SphereGeometry(0.06,16,16), new THREE.MeshBasicMaterial({color:c}));}
  const d1=makeDot(0x22d3ee), d2=makeDot(0x8b5cf6), d3=makeDot(0xec4899);
  scene.add(d1,d2,d3);

  scene.add(new THREE.AmbientLight(0x404060,1));
  const kl=new THREE.PointLight(0x22d3ee,4,20); kl.position.set(4,4,4); scene.add(kl);
  const fl=new THREE.PointLight(0x8b5cf6,3,20); fl.position.set(-4,-2,4); scene.add(fl);
  const rl=new THREE.PointLight(0xec4899,2,20); rl.position.set(0,-4,-4); scene.add(rl);
  const tl=new THREE.DirectionalLight(0xffffff,1.5); tl.position.set(0,5,0); scene.add(tl);

  let tRX = 0.2, tRY = 0, mouseInside = false;
  canvas.parentElement.addEventListener('mousemove', (e) => {
    const r = canvas.parentElement.getBoundingClientRect();
    const x = ((e.clientX-r.left)/r.width)*2-1;
    const y = ((e.clientY-r.top)/r.height)*2-1;
    tRY = x*0.8; tRX = 0.2-y*0.5; mouseInside = true;
  });
  canvas.parentElement.addEventListener('mouseleave', () => { mouseInside = false; });

  let f = 0;
  function loop() {
    requestAnimationFrame(loop);
    f += 0.01;
    if (!mouseInside) tRY += 0.005;
    diamond.rotation.y += (tRY - diamond.rotation.y)*0.06;
    diamond.rotation.x += (tRX - diamond.rotation.x)*0.06;
    diamond.position.y = Math.sin(f*0.8)*0.1;

    const pp = points.geometry.attributes.position.array;
    for (let i = 0; i < pCount; i++) {
      pp[i*3]+=pVel[i*3]; pp[i*3+1]+=pVel[i*3+1]; pp[i*3+2]+=pVel[i*3+2];
      const dx=pp[i*3], dy=pp[i*3+1], dz=pp[i*3+2];
      const d = Math.sqrt(dx*dx+dy*dy+dz*dz);
      if (d>5||d<2){pVel[i*3]*=-1;pVel[i*3+1]*=-1;pVel[i*3+2]*=-1;}
    }
    points.geometry.attributes.position.needsUpdate = true;
    points.rotation.y += 0.001;

    r1.rotation.z += 0.005; r2.rotation.z -= 0.003; r3.rotation.z += 0.004;
    d1.position.set(2.4*Math.cos(f*1.2), 2.4*Math.sin(f*1.2)*Math.cos(Math.PI/3), 2.4*Math.sin(f*1.2)*Math.sin(Math.PI/3));
    d2.position.set(2.8*Math.cos(f*0.8+1)*Math.cos(Math.PI/3), 2.8*Math.sin(f*0.8+1), 2.8*Math.cos(f*0.8+1)*Math.sin(Math.PI/3));
    d3.position.set(3.2*Math.cos(f*0.6+2)*Math.cos(Math.PI/4), 3.2*Math.sin(f*0.6+2)*Math.cos(Math.PI/4), 3.2*Math.sin(f*0.6+2)*Math.sin(Math.PI/4));

    kl.position.x = 4*Math.cos(f*0.5); kl.position.z = 4*Math.sin(f*0.5);
    fl.position.x = -4*Math.cos(f*0.3); fl.position.y = -2*Math.sin(f*0.3);
    halo2.scale.setScalar(1+Math.sin(f*1.5)*0.05);

    renderer.render(scene, camera);
  }

  resize();
  loop();
  window.addEventListener('resize', resize);
})();


function getModelUrl(file) {
  return (window.KARIA_MODEL_URLS && window.KARIA_MODEL_URLS[file]) || file;
}

/* HERO PRODUCT MODEL CAROUSEL — handled by inline procedural code in karia-home.liquid */
(function initHeroModelCarousel() {
  // OBJ-file version disabled: assets not available. Procedural version in karia-home.liquid.
  return;
  const canvas = document.getElementById('hero-canvas');
  const panel = document.getElementById('heroProdPanel');
  const loading = document.getElementById('heroModelLoading');
  const label = document.getElementById('heroModelLabel');
  const prev = document.getElementById('heroModelPrev');
  const next = document.getElementById('heroModelNext');
  if (!canvas || !panel) return;

  const products = [
    { name:'Single Crystal Diamond Plate', file:'single-crystal.obj', material:'crystal', color:0x9ee7ff, spin:0.006 },
    { name:'Polycrystalline Diamond', file:'polycrystal.obj', material:'matte', color:0x8ed7b0, spin:0.005 },
    { name:'Diamond Heat Sinks', file:'heat-sinks.obj', material:'ceramic', color:0xd8eef8, spin:0.005 },
    { name:'Diamond Heat Spreaders', file:'heat-spreaders.obj', material:'crystal', color:0xb8f3ff, spin:0.006 },
    { name:'Semiconductor Substrates', file:'substrates.obj', material:'substrate', color:0xaedcff, spin:0.006 },
    { name:'Boron Doped Diamond', file:'boron-doped.obj', material:'boron', color:0x6f8dff, spin:0.006 },
    { name:'Quantum Diamonds', file:'quantum.obj', material:'quantum', color:0x8beaff, spin:0.007 },
    { name:'Diamond Optics', file:'optics.obj', material:'optic', color:0xd7f8ff, spin:0.005 },
    { name:'Diamond Powders', file:'powders.obj', material:'powder', color:0xf5d278, spin:0.004 }
  ];

  const renderer = new THREE.WebGLRenderer({ canvas, alpha:true, antialias:true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.outputEncoding = THREE.sRGBEncoding;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
  camera.position.set(0, 0.55, 7.4);

  const root = new THREE.Group();
  scene.add(root);

  const halo = new THREE.Mesh(
    new THREE.SphereGeometry(2.65, 48, 48),
    new THREE.MeshBasicMaterial({ color:0x22d3ee, transparent:true, opacity:0.055, side:THREE.BackSide })
  );
  scene.add(halo);

  function ring(radius, color, opacity, rot) {
    const mesh = new THREE.Mesh(
      new THREE.TorusGeometry(radius, 0.006, 8, 160),
      new THREE.MeshBasicMaterial({ color, transparent:true, opacity, side:THREE.DoubleSide })
    );
    mesh.rotation.set(rot[0], rot[1], rot[2]);
    scene.add(mesh);
    return mesh;
  }
  const rings = [
    ring(2.45, 0x22d3ee, 0.26, [Math.PI/3, 0, 0]),
    ring(2.85, 0x8b5cf6, 0.20, [0, Math.PI/3, Math.PI/4]),
    ring(3.18, 0xec4899, 0.16, [Math.PI/4, Math.PI/4, 0])
  ];

  scene.add(new THREE.AmbientLight(0xb7d9ff, 0.62));
  const key = new THREE.PointLight(0x22d3ee, 3.4, 18); key.position.set(4, 4, 5); scene.add(key);
  const fill = new THREE.PointLight(0x8b5cf6, 2.4, 18); fill.position.set(-4, 1.4, 4); scene.add(fill);
  const rim = new THREE.PointLight(0xec4899, 1.8, 18); rim.position.set(0, -3, -4); scene.add(rim);
  const top = new THREE.DirectionalLight(0xffffff, 1.6); top.position.set(0, 5, 2); scene.add(top);

  const loader = new THREE.OBJLoader();
  const cache = new Map();
  let activeIndex = 0;
  let activeObject = null;
  let targetRotX = -0.28;
  let targetRotY = 0.62;
  let mouseInside = false;
  let raf = null;
  let timer = null;

  function makeMaterial(type, color) {
    const base = { color, side:THREE.DoubleSide };
    if (type === 'crystal' || type === 'optic') {
      return new THREE.MeshPhysicalMaterial({ ...base, metalness:0, roughness:0.08, transmission:type === 'optic' ? 0.72 : 0.48, transparent:true, opacity:type === 'optic' ? 0.58 : 0.46, clearcoat:1, clearcoatRoughness:0.04, reflectivity:0.95 });
    }
    if (type === 'powder') {
      return new THREE.MeshStandardMaterial({ ...base, roughness:0.78, metalness:0.05, emissive:0x2a1d08, emissiveIntensity:0.15 });
    }
    if (type === 'boron') {
      return new THREE.MeshPhysicalMaterial({ ...base, roughness:0.2, metalness:0.15, transparent:true, opacity:0.86, clearcoat:0.7, emissive:0x101c62, emissiveIntensity:0.22 });
    }
    if (type === 'quantum') {
      return new THREE.MeshPhysicalMaterial({ ...base, roughness:0.12, metalness:0, transparent:true, opacity:0.72, clearcoat:1, emissive:0x063846, emissiveIntensity:0.25 });
    }
    return new THREE.MeshStandardMaterial({ ...base, roughness:type === 'matte' ? 0.72 : 0.32, metalness:type === 'ceramic' ? 0.08 : 0.02 });
  }

  function normalizeObject(obj, product) {
    obj.traverse(child => {
      if (!child.isMesh) return;
      child.geometry.computeVertexNormals();
      child.material = makeMaterial(product.material, product.color);
    });
    const box = new THREE.Box3().setFromObject(obj);
    const center = box.getCenter(new THREE.Vector3());
    const size = box.getSize(new THREE.Vector3());
    obj.position.sub(center);
    const maxDim = Math.max(size.x, size.y, size.z) || 1;
    obj.scale.setScalar(3.35 / maxDim);
    obj.rotation.set(-0.42, 0.58, 0.08);
    return obj;
  }

  function resize() {
    const w = canvas.parentElement.clientWidth;
    const h = canvas.parentElement.clientHeight;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }

  function setLoading(isLoading) {
    if (loading) loading.classList.toggle('hidden', !isLoading);
  }

  function show(index) {
    activeIndex = (index + products.length) % products.length;
    const product = products[activeIndex];
    panel.querySelectorAll('.hcp-item').forEach((item, i) => item.classList.toggle('active', i === activeIndex));
    panel.querySelectorAll('.hcp-dot').forEach((dot, i) => dot.classList.toggle('active', i === activeIndex));
    if (label) label.textContent = product.name;
    setLoading(true);

    function mount(obj) {
      root.clear();
      activeObject = obj.clone(true);
      activeObject.traverse(child => {
        if (child.isMesh && child.material) child.material = child.material.clone();
      });
      activeObject.rotation.y = 0.58;
      root.add(activeObject);
      setLoading(false);
    }

    if (cache.has(product.file)) {
      mount(cache.get(product.file));
      return;
    }

    loader.load(
      getModelUrl(product.file),
      obj => {
        const normalized = normalizeObject(obj, product);
        cache.set(product.file, normalized);
        if (products[activeIndex].file === product.file) mount(normalized);
      },
      undefined,
      () => {
        setLoading(false);
        if (label) label.textContent = product.name + ' unavailable';
      }
    );
  }

  function preloadLightModels() {
    products.slice(1, 7).forEach(product => {
      if (cache.has(product.file)) return;
      window.setTimeout(() => {
        if (cache.has(product.file)) return;
        loader.load(getModelUrl(product.file), obj => {
          cache.set(product.file, normalizeObject(obj, product));
        });
      }, 350);
    });
  }

  function schedule() {
    window.clearInterval(timer);
    timer = window.setInterval(() => show(activeIndex + 1), 5200);
  }

  canvas.parentElement.addEventListener('mousemove', e => {
    const r = canvas.parentElement.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 2 - 1;
    const y = ((e.clientY - r.top) / r.height) * 2 - 1;
    targetRotY = 0.62 + x * 0.5;
    targetRotX = -0.28 - y * 0.22;
    mouseInside = true;
  });
  canvas.parentElement.addEventListener('mouseleave', () => { mouseInside = false; });

  panel.querySelectorAll('.hcp-dot').forEach(dot => {
    dot.addEventListener('click', () => { show(+dot.dataset.idx); schedule(); });
  });
  if (prev) prev.addEventListener('click', () => { show(activeIndex - 1); schedule(); });
  if (next) next.addEventListener('click', () => { show(activeIndex + 1); schedule(); });

  function loop() {
    raf = requestAnimationFrame(loop);
    const t = performance.now() * 0.001;
    const product = products[activeIndex];
    if (!mouseInside) targetRotY += product.spin;
    if (activeObject) {
      activeObject.rotation.y += (targetRotY - activeObject.rotation.y) * 0.055;
      activeObject.rotation.x += (targetRotX - activeObject.rotation.x) * 0.055;
      activeObject.position.y = Math.sin(t * 1.15) * 0.08;
    }
    root.rotation.z = Math.sin(t * 0.5) * 0.025;
    halo.scale.setScalar(1 + Math.sin(t * 1.4) * 0.045);
    rings[0].rotation.z += 0.004;
    rings[1].rotation.z -= 0.003;
    rings[2].rotation.z += 0.0025;
    key.position.x = 4 * Math.cos(t * 0.55);
    key.position.z = 4 * Math.sin(t * 0.55);
    renderer.render(scene, camera);
  }

  window.KariaHeroModels = { goTo: show };
  resize();
  show(0);
  preloadLightModels();
  schedule();
  loop();
  window.addEventListener('resize', resize);
  window.addEventListener('beforeunload', () => { cancelAnimationFrame(raf); window.clearInterval(timer); });
})();

/* PRODUCT CARD 3D THUMBNAILS — Procedural (no OBJ files needed) */
(function initProductCardModels() {
  if (typeof THREE === 'undefined') return;
  const canvases = document.querySelectorAll('.bento-model[data-model]');
  if (!canvases.length) return;

  function buildProceduralModel(type, colorHex) {
    const color = parseInt(colorHex, 16);
    const g = new THREE.Group();

    if (type === 'ceramic' || type === 'heat-sinks') {
      // Heat sink: single gold square flat wafer
      const goldColor = 0xd4a437;
      const waferMat = new THREE.MeshPhysicalMaterial({ color: goldColor, roughness: 0.12, metalness: 0.75, clearcoat: 0.9, clearcoatRoughness: 0.08, side: THREE.DoubleSide });
      const wafer = new THREE.Mesh(new THREE.BoxGeometry(1.7, 0.09, 1.7), waferMat);
      g.add(wafer);
      const edges = new THREE.LineSegments(new THREE.EdgesGeometry(wafer.geometry), new THREE.LineBasicMaterial({ color: 0xf0c050, transparent: true, opacity: 0.7 }));
      g.add(edges);

    } else if (type === 'crystal' || type === 'substrate' || type === 'substrates') {
      // Substrate: flat transparent square plate
      const mat = new THREE.MeshPhysicalMaterial({ color, roughness: 0.05, metalness: 0, transparent: true, opacity: 0.5, transmission: 0.45, clearcoat: 1, side: THREE.DoubleSide });
      const plate = new THREE.Mesh(new THREE.BoxGeometry(1.5, 0.10, 1.5, 4, 1, 4), mat);
      g.add(plate);
      const edges = new THREE.LineSegments(new THREE.EdgesGeometry(plate.geometry), new THREE.LineBasicMaterial({ color, transparent: true, opacity: 0.8 }));
      g.add(edges);

    } else if (type === 'optic' || type === 'optics') {
      // Optical window: round transparent flat disc — no dome, no torus
      const discMat = new THREE.MeshPhysicalMaterial({ color: 0xd7f8ff, roughness: 0.02, metalness: 0, transparent: true, opacity: 0.32, transmission: 0.78, clearcoat: 1, clearcoatRoughness: 0.02, reflectivity: 0.95, side: THREE.DoubleSide });
      const disc = new THREE.Mesh(new THREE.CylinderGeometry(1.25, 1.25, 0.08, 80), discMat);
      g.add(disc);
      // Rim highlight edges
      const rimGeo = new THREE.EdgesGeometry(new THREE.CylinderGeometry(1.25, 1.25, 0.08, 80));
      g.add(new THREE.LineSegments(rimGeo, new THREE.LineBasicMaterial({ color: 0x88e8f8, transparent: true, opacity: 0.82 })));

    } else if (type === 'boron') {
      // Boron-doped: square purple wafer — matches the product detail page
      const mat = new THREE.MeshPhysicalMaterial({ color: 0xa78bfa, roughness: 0.15, metalness: 0.1, transparent: true, opacity: 0.88, clearcoat: 0.8, emissive: 0x101c62, emissiveIntensity: 0.3, side: THREE.DoubleSide });
      const wafer = new THREE.Mesh(new THREE.BoxGeometry(1.6, 0.11, 1.6, 8, 1, 8), mat);
      g.add(wafer);
      g.add(new THREE.LineSegments(new THREE.EdgesGeometry(wafer.geometry), new THREE.LineBasicMaterial({ color: 0x8b5cf6, transparent: true, opacity: 0.7 })));

    } else if (type === 'quantum') {
      // Quantum diamond: square flat wafer in brownish-rose color
      const roseColor = 0xc07860;
      const waferMat = new THREE.MeshPhysicalMaterial({ color: roseColor, roughness: 0.14, metalness: 0.05, transparent: true, opacity: 0.85, clearcoat: 0.85, clearcoatRoughness: 0.06, emissive: 0x3d1510, emissiveIntensity: 0.15, side: THREE.DoubleSide });
      const wafer = new THREE.Mesh(new THREE.BoxGeometry(1.55, 0.09, 1.55), waferMat);
      g.add(wafer);
      const edges = new THREE.LineSegments(new THREE.EdgesGeometry(wafer.geometry), new THREE.LineBasicMaterial({ color: 0xe09070, transparent: true, opacity: 0.6 }));
      g.add(edges);

    } else {
      // Powder: green/teal multi-size particle cloud + faint core sphere — matches the product detail page
      const dotTex = (() => { const dc = document.createElement('canvas'); dc.width = 32; dc.height = 32; const cx = dc.getContext('2d'); cx.beginPath(); cx.arc(16, 16, 14, 0, Math.PI * 2); cx.fillStyle = 'white'; cx.fill(); return new THREE.CanvasTexture(dc); })();
      const sizes = [0.03, 0.05, 0.08, 0.11, 0.15];
      const colors = [0x4ade80, 0x22d3ee, 0xa7f3d0, 0x6ee7b7, 0x34d399];
      for (let s = 0; s < sizes.length; s++) {
        const n = 70 - s * 10; const pos = new Float32Array(n * 3);
        for (let i = 0; i < n; i++) { const r = 0.45 + Math.random() * 0.85, t = Math.random() * Math.PI * 2, p = Math.acos(2 * Math.random() - 1); pos[i*3] = r*Math.sin(p)*Math.cos(t); pos[i*3+1] = r*Math.sin(p)*Math.sin(t)*0.7; pos[i*3+2] = r*Math.cos(p); }
        const geo = new THREE.BufferGeometry(); geo.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
        g.add(new THREE.Points(geo, new THREE.PointsMaterial({ size: sizes[s], color: colors[s], transparent: true, opacity: 0.85, map: dotTex, alphaTest: 0.4 })));
      }
      g.add(new THREE.Mesh(new THREE.SphereGeometry(0.4, 16, 16), new THREE.MeshBasicMaterial({ color: 0x4ade80, transparent: true, opacity: 0.08 })));
    }
    return g;
  }

  canvases.forEach(canvas => {
    const modelType = canvas.dataset.material || canvas.dataset.model.replace('.obj', '');
    const colorHex = canvas.dataset.color || 'aedcff';
    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(42, 1, 0.1, 50);
    camera.position.set(0, 1.8, 3.8);
    camera.lookAt(0, 0, 0);
    scene.add(new THREE.AmbientLight(0xb7d9ff, 0.7));
    const key = new THREE.PointLight(0x22d3ee, 2.8, 14); key.position.set(3, 3, 4); scene.add(key);
    const fill = new THREE.PointLight(0x8b5cf6, 1.8, 14); fill.position.set(-3, 1, 3); scene.add(fill);
    const model = buildProceduralModel(modelType, colorHex);
    scene.add(model);
    let raf;
    function resize() {
      const w = canvas.parentElement.clientWidth || 200;
      const h = canvas.parentElement.clientHeight || 200;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    }
    function loop() {
      raf = requestAnimationFrame(loop);
      model.rotation.y += 0.008;
      renderer.render(scene, camera);
    }
    resize();
    loop();
    window.addEventListener('resize', resize);
    canvas.addEventListener('remove', () => { cancelAnimationFrame(raf); renderer.dispose(); });
  });
})();

/* TECH 3D — Crystal Lattice */
(function initTech3D() {
  if (typeof THREE === 'undefined') return;
  const canvas = document.getElementById('tech-canvas');
  if (!canvas) return;

  const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(45, 1, 0.1, 100);
  camera.position.set(0, 0, 8);

  function resize() {
    const w = canvas.parentElement.clientWidth;
    const h = canvas.parentElement.clientHeight;
    renderer.setSize(w, h, false);
    camera.aspect = w/h;
    camera.updateProjectionMatrix();
  }

  const lattice = new THREE.Group();
  const sg = new THREE.SphereGeometry(0.08, 16, 16);
  const positions = [];
  const sp = 0.7;
  [-1,0,1].forEach(x => [-1,0,1].forEach(y => [-1,0,1].forEach(z => {
    const p = new THREE.Vector3(x*sp, y*sp, z*sp);
    positions.push(p);
    const m = new THREE.MeshPhongMaterial({color:0x22d3ee,emissive:0x0e7490,emissiveIntensity:0.5,shininess:200});
    const s = new THREE.Mesh(sg, m); s.position.copy(p); lattice.add(s);
  })));

  const linePos = [];
  for (let i = 0; i < positions.length; i++) {
    for (let j = i+1; j < positions.length; j++) {
      if (positions[i].distanceTo(positions[j]) < sp*1.1) {
        linePos.push(positions[i].x,positions[i].y,positions[i].z,positions[j].x,positions[j].y,positions[j].z);
      }
    }
  }
  const lg = new THREE.BufferGeometry();
  lg.setAttribute('position', new THREE.Float32BufferAttribute(linePos,3));
  lattice.add(new THREE.LineSegments(lg, new THREE.LineBasicMaterial({color:0x7dd3fc,transparent:true,opacity:0.3})));
  scene.add(lattice);

  const outer = new THREE.Mesh(new THREE.IcosahedronGeometry(2.5,1), new THREE.MeshBasicMaterial({color:0x8b5cf6,wireframe:true,transparent:true,opacity:0.15}));
  scene.add(outer);
  const glow = new THREE.Mesh(new THREE.SphereGeometry(0.5,32,32), new THREE.MeshBasicMaterial({color:0x22d3ee,transparent:true,opacity:0.3}));
  scene.add(glow);

  scene.add(new THREE.AmbientLight(0x404060,0.8));
  const p1 = new THREE.PointLight(0x22d3ee,2,15); p1.position.set(3,3,3); scene.add(p1);
  const p2 = new THREE.PointLight(0x8b5cf6,1.5,15); p2.position.set(-3,-3,-3); scene.add(p2);

  let tx=0, ty=0;
  canvas.parentElement.addEventListener('mousemove', (e) => {
    const r = canvas.parentElement.getBoundingClientRect();
    tx = ((e.clientX-r.left)/r.width-0.5)*2;
    ty = ((e.clientY-r.top)/r.height-0.5)*2;
  });

  let f = 0;
  function loop() {
    requestAnimationFrame(loop);
    f += 0.01;
    lattice.rotation.y += 0.005 + tx*0.005;
    lattice.rotation.x += 0.002 - ty*0.005;
    outer.rotation.y -= 0.003; outer.rotation.x += 0.002;
    glow.scale.setScalar(1+Math.sin(f*2)*0.2);
    p1.position.x = 3*Math.cos(f); p1.position.z = 3*Math.sin(f);
    renderer.render(scene, camera);
  }
  resize();
  loop();
  window.addEventListener('resize', resize);
})();

/* HERO PRODUCT CAROUSEL — DISABLED.
   The inline carousel in sections/karia-s-hero.liquid is the single source of truth
   (it advances model + label + card + dots together via show()). This duplicate ran on
   its own 4s timer and toggled only the card/dot — desyncing the card from the 3D model. */
(function(){
  return;
  const panel = document.getElementById('heroProdPanel');
  if(!panel || window.KariaHeroModels) return;
  const items = panel.querySelectorAll('.hcp-item');
  const dots  = panel.querySelectorAll('.hcp-dot');
  function goTo(idx){
    items.forEach(i => i.classList.remove('active'));
    dots.forEach(d  => d.classList.remove('active'));
    items[idx].classList.add('active');
    dots[idx].classList.add('active');
  }
  dots.forEach(d => d.addEventListener('click', () => goTo(+d.dataset.idx)));
  // Auto-advance every 4 s
  let cur = 0;
  setInterval(() => { cur = (cur + 1) % items.length; goTo(cur); }, 4000);
})();

/* PRODUCT DETAIL 3D — Single Crystal Wafer 3D viewer */
(function initProduct3D() {
  if (typeof THREE === 'undefined') return;
  const canvas = document.getElementById('product-canvas');
  if (!canvas) return;

  const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(40, 1, 0.1, 100);
  camera.position.set(0, 1.5, 5);
  camera.lookAt(0, 0, 0);

  function resize() {
    const w = canvas.parentElement.clientWidth;
    const h = canvas.parentElement.clientHeight;
    renderer.setSize(w, h, false);
    camera.aspect = w/h;
    camera.updateProjectionMatrix();
  }

  // Wafer (cylinder)
  const waferGeo = new THREE.CylinderGeometry(1.5, 1.5, 0.08, 64, 1);
  const waferMat = new THREE.MeshPhongMaterial({
    color: 0x2a3550,
    shininess: 300,
    specular: 0xa5dcff,
    transparent: true,
    opacity: 0.95
  });
  const wafer = new THREE.Mesh(waferGeo, waferMat);
  scene.add(wafer);

  // Wafer top — gradient/iridescent surface
  const surfaceGeo = new THREE.CircleGeometry(1.5, 64);
  const surfaceMat = new THREE.MeshPhongMaterial({
    color: 0x65c2ff,
    shininess: 400,
    specular: 0xffffff,
    transparent: true,
    opacity: 0.6,
    side: THREE.DoubleSide
  });
  const surface = new THREE.Mesh(surfaceGeo, surfaceMat);
  surface.rotation.x = -Math.PI/2;
  surface.position.y = 0.041;
  scene.add(surface);

  // Edge ring
  const ringGeo = new THREE.TorusGeometry(1.5, 0.01, 8, 64);
  const ringMat = new THREE.MeshBasicMaterial({color:0xd6f1ff,transparent:true,opacity:0.7});
  const ring = new THREE.Mesh(ringGeo, ringMat);
  ring.rotation.x = Math.PI/2;
  scene.add(ring);

  // Concentric rings on surface (crystal pattern)
  for (let i = 1; i <= 6; i++) {
    const r = i * 0.22;
    const rg = new THREE.RingGeometry(r, r+0.005, 64);
    const rm = new THREE.MeshBasicMaterial({color:0xa5dcff, transparent:true, opacity:0.15, side:THREE.DoubleSide});
    const rmesh = new THREE.Mesh(rg, rm);
    rmesh.rotation.x = -Math.PI/2;
    rmesh.position.y = 0.042;
    scene.add(rmesh);
  }

  // Particle dust
  const pCount = 100;
  const pPos = new Float32Array(pCount*3);
  for (let i = 0; i < pCount; i++) {
    pPos[i*3] = (Math.random()-0.5)*6;
    pPos[i*3+1] = (Math.random()-0.5)*4;
    pPos[i*3+2] = (Math.random()-0.5)*6;
  }
  const pGeo = new THREE.BufferGeometry();
  pGeo.setAttribute('position', new THREE.Float32BufferAttribute(pPos,3));
  const points = new THREE.Points(pGeo, new THREE.PointsMaterial({size:0.025,color:0x22d3ee,transparent:true,opacity:0.6}));
  scene.add(points);

  // Lights
  scene.add(new THREE.AmbientLight(0x405070,0.5));
  const key = new THREE.PointLight(0x22d3ee,3,12); key.position.set(3,4,3); scene.add(key);
  const fill = new THREE.PointLight(0x8b5cf6,2.5,12); fill.position.set(-3,2,3); scene.add(fill);
  const rim = new THREE.PointLight(0xec4899,2,12); rim.position.set(0,-3,-3); scene.add(rim);
  const top = new THREE.DirectionalLight(0xffffff,1); top.position.set(0,5,0); scene.add(top);

  let tx=0, ty=0;
  canvas.parentElement.addEventListener('mousemove', (e) => {
    const r = canvas.parentElement.getBoundingClientRect();
    tx = ((e.clientX-r.left)/r.width-0.5)*2;
    ty = ((e.clientY-r.top)/r.height-0.5)*2;
  });

  let f = 0;
  function loop() {
    requestAnimationFrame(loop);
    f += 0.008;
    wafer.rotation.y += 0.005 + tx*0.005;
    surface.rotation.z += 0.003;
    ring.rotation.z = wafer.rotation.y;
    wafer.rotation.x += (ty*0.3 - wafer.rotation.x)*0.05;
    surface.rotation.x = -Math.PI/2 + wafer.rotation.x*0.5;

    points.rotation.y += 0.001;
    key.position.x = 3*Math.cos(f);
    key.position.z = 3*Math.sin(f);

    renderer.render(scene, camera);
  }
  resize();
  loop();
  window.addEventListener('resize', resize);
})();

/* PRODUCT TABS (product detail page) */
document.querySelectorAll('[data-tab]').forEach(tab => {
  tab.addEventListener('click', () => {
    const target = tab.dataset.tab;
    const wrap = tab.closest('.tabs-wrap');
    if (!wrap) return;
    wrap.querySelectorAll('[data-tab]').forEach(t => t.classList.remove('active'));
    wrap.querySelectorAll('[data-panel]').forEach(p => p.classList.remove('active'));
    tab.classList.add('active');
    const panel = wrap.querySelector(`[data-panel="${target}"]`);
    if (panel) panel.classList.add('active');
  });
});

/* QTY input (product detail) */
document.querySelectorAll('.qty-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const wrap = btn.closest('.qty-wrap');
    const input = wrap.querySelector('.qty-input');
    let v = parseInt(input.value) || 1;
    if (btn.dataset.qty === 'minus' && v > 1) v--;
    if (btn.dataset.qty === 'plus') v++;
    input.value = v;
  });
});

/* PRODUCT GALLERY (product detail thumb selector) */
document.querySelectorAll('.gallery-thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    const view = document.querySelector('.gallery-main-view');
    if (view) {
      const target = thumb.dataset.view;
      view.querySelectorAll('.gallery-view').forEach(v => v.classList.remove('active'));
      const t = view.querySelector(`[data-view="${target}"]`);
      if (t) t.classList.add('active');
    }
  });
});
